import { useState } from 'react';

const AddProductPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddProductPopup, setShowAddProductPopup] =
      useState<boolean>(false);

    const addToggleHandler = (isEdit = false) => {
      localStorage.setItem('images', JSON.stringify([]));
      setShowAddProductPopup(!isEdit ? !showAddProductPopup : isEdit);
    };

    return (
      <Component
        showAddProductPopup={showAddProductPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddProductPopupHOC;
